import api from "../services/api";

function initArticleLinkClickListener() {
  const elements = document.querySelectorAll(".article-content") as NodeListOf<HTMLElement>;

  elements.forEach((element) => {
    const articleId = element.getAttribute("data-article-id");

    if (articleId) {
      element.querySelectorAll("a").forEach((link) => {
        const url = link.getAttribute("href");

        if (url) {
          link.addEventListener("click", () => {
            api.articleLinkClick(articleId, url);
          });
        }
      });
    } else {
      console.warn("Article id not specified for element", element);
    }
  });
}

document.addEventListener("DOMContentLoaded", initArticleLinkClickListener);
